var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export const NavLink = styled.a.withConfig({
  displayName: "Link__NavLink",
  componentId: "sc-p03dmj-0"
})(["display:flex;justify-content:space-between;padding:14px 18px 14px 16px;font-weight:400;font-size:16px;line-height:16px;color:", ";svg{align-self:center;}&:hover{background-color:", ";color:", ";}", ";span{width:fit-content;}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.font;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.uiL;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.primary;
}, minMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 14px 24px 14px 36px;\n  "]))));